'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Note = require('./Note');

var _Note2 = _interopRequireDefault(_Note);

var _CommentInput = require('./CommentInput');

var _CommentInput2 = _interopRequireDefault(_CommentInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Notes = function (_React$Component) {
	_inherits(Notes, _React$Component);

	function Notes(props) {
		_classCallCheck(this, Notes);

		var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this, props));

		_this.state = {
			notes: INITIAL_NOTES || []
		};

		_this.renderNotes = _this._renderNotes.bind(_this);
		_this.onSubmitComment = _this._onSubmitComment.bind(_this);
		_this.onClickDelete = _this._onClickDelete.bind(_this);
		return _this;
	}

	_createClass(Notes, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'notes' },
				this.renderNotes(),
				_react2.default.createElement(
					'div',
					{ className: 'comment' },
					_react2.default.createElement(_CommentInput2.default, {
						onSubmit: this.onSubmitComment
					})
				)
			);
		}
	}, {
		key: '_renderNotes',
		value: function _renderNotes() {
			var _this2 = this;

			return this.state.notes.map(function (note, i) {
				return _react2.default.createElement(_Note2.default, _extends({
					onSubmitComment: _this2.onSubmitComment,
					onClickDelete: _this2._onClickDelete.bind(_this2, note),
					key: i }, note));
			});
		}
	}, {
		key: '_onSubmitComment',
		value: function _onSubmitComment(comment) {
			var _this3 = this;

			var url = '/ajax' + location.pathname + '/comments';
			var headers = new Headers();
			headers.append('Content-Type', 'application/json');
			headers.append('X-CSRF-TOKEN', CSRF_TOKEN);

			var request = new Request(url, {
				credentials: 'same-origin',
				headers: headers,
				method: 'POST',
				body: JSON.stringify({ comment: comment })
			});

			fetch(request).then(function (response) {
				return response.json();
			}).then(function (response) {
				_this3.setState({
					notes: response
				});
			}).catch(function (e) {
				return console.log(e);
			});;
		}
	}, {
		key: '_onClickDelete',
		value: function _onClickDelete(comment) {
			var _this4 = this;

			var url = '/ajax' + location.pathname + '/comments/' + comment.id;
			var headers = new Headers();
			headers.append('Content-Type', 'application/json');
			headers.append('X-CSRF-TOKEN', CSRF_TOKEN);

			var request = new Request(url, {
				credentials: 'same-origin',
				headers: headers,
				method: 'POST',
				body: JSON.stringify({ _method: 'delete' })
			});

			fetch(request).then(function (response) {
				return response.json();
			}).then(function (response) {
				_this4.setState({
					notes: response
				});
			}).catch(function (e) {
				return console.log(e);
			});;
		}
	}]);

	return Notes;
}(_react2.default.Component);

exports.default = Notes;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/notes/Notes.js
// module id = 517
// module chunks = 0